import { FC, useEffect } from 'react';
import { Title } from '@mantine/core';
import { CheckboxGroup } from 'src/components';
import { IWidgetOptions } from '@common/types/types';
import { useTranslation } from 'react-i18next';
import extractOptions from 'src/helpers/extractOptions';

interface Props {
  state: IWidgetOptions[];
  handleGroupCheckboxChange: (groupIndex: number, isChecked: boolean) => void;
  handleCheckboxChange: (id: string, isChecked: boolean) => void;
  icon: string;
  setIcon: (icon: string) => void;
  setWidgetState: (value: any) => void;
}

export const WidgetOptions: FC<Props> = ({
  state,
  handleCheckboxChange,
  handleGroupCheckboxChange,
  setWidgetState,
}) => {
  const [t] = useTranslation('widget');

  useEffect(() => {
    const newOptions = extractOptions(state);
    setWidgetState((prevState: any) => {
      return {
        ...prevState,
        options: newOptions,
      };
    });
  }, [state]);

  return (
    <>
      <Title order={2} fw={'bold'} size={'18px'}>
        {t('widgetOption')}
      </Title>
      {state.map((option: IWidgetOptions, index: number) => (
        <CheckboxGroup
          key={option.id}
          group={option}
          groupIndex={index}
          handleCheckboxChange={handleCheckboxChange}
          handleGroupCheckboxChange={handleGroupCheckboxChange}
        />
      ))}
    </>
  );
};
